import { namespaceActions } from 'modules/app-core/redux-utils'
import { NAME } from './constants'

export const LOAD_BENEFITEFFECTIVEDATES = 'LOAD_BENEFITEFFECTIVEDATES'

export default namespaceActions(NAME)([LOAD_BENEFITEFFECTIVEDATES])
